export const initialState = {
  currentVideo: undefined,
};
